import meta from "./auto-generated/meta.json";

type MetaEntry = {
  slug?: string;
  title?: string;
  description?: string;
};

export const Meta: MetaEntry[] = meta;
